<template>
	<div class="fullPage">
		<div class="fullPage-body">
			<div class="nav">
				<div class="nav-block blockFirst">
					<div class="nav-margin-left">
						<img src="../../assets/img/already.png" class="firstImg" />
						<div class="blockFirst-l-title">简牍科技车位营销数据</div>
					</div>
					<div class="nav-margin-right">
						<img src="../../assets/imgnew/i-phone.png" class="blockFirst-r-img" />
						<div class="blockFirst-r-title">移动端查看数据</div>
					</div>
				</div>
				<div class="nav-block blockSecond">
					<div class="nav-margin-left">
						<div class="nav-second-l">
							<div class="nav-second-l-title">全部城市</div>
							<img src="../../assets/imgnew/arrow-d-w.png" class="nav-second-l-img" />
						</div>
						<div class="nav-second-c">
							<div class="nav-second-c-title">全部项目</div>
							<img src="../../assets/imgnew/arrow-d-g.png" class="nav-second-c-img" />
						</div>
						<div class="nav-second-r">
							<div class="nav-second-r-title">15825个车位</div>
							<div class="nav-second-r-title nav-second-r-margin">19781户</div>
							<div class="nav-second-r-title nav-second-r-margin">车位配比1:25</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 车位数据总览 -->
			<div class="data-block">
				<div class="data-head">
					<div class="data-head-left">
						<div class="data-head-title">车位数据总览</div>
						<div class="data-time-block">
							<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
							<div class="data-time-title">10/18 周三</div>
							<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
						</div>
					</div>
				</div>
				<div class="data-content">
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
				</div>
			</div>
			<!-- 今日销售数据 -->
			<div class="data-block">
				<div class="data-head">
					<div class="data-head-left">
						<div class="data-head-title">今日销售数据</div>
						<div class="data-time-block">
							<div class="data-time-dot"></div>
							<div class="data-time-title">数据时间2025-12-25 18:33</div>
						</div>
					</div>
				</div>
				<div class="data-content">
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
				</div>
			</div>
			<!-- 今日跟进数据 -->
			<div class="data-block">
				<div class="data-head">
					<div class="data-head-left">
						<div class="data-head-title">今日跟进数据</div>
						<div class="data-time-block">
							<div class="data-time-dot"></div>
							<div class="data-time-title">数据时间2025-12-25 18:33</div>
						</div>
					</div>
				</div>
				<div class="data-content">
					<div class="data-i-block" style="width: 1504px;height: 374px;"></div>
				</div>
			</div>
			<!-- 昨日销售数据 -->
			<div class="data-block">
				<div class="data-head">
					<div class="data-head-left">
						<div class="data-head-title">昨日销售数据</div>
						<div class="data-time-block">
							<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
							<div class="data-time-title">10/18 周三</div>
							<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
						</div>
					</div>
				</div>
				<div class="data-content">
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
					<div class="data-i-block data-i-size"></div>
				</div>
			</div>
			<!-- 销售趋势 -->
			<div class="data-block">
				<div class="data-head">
					<div class="data-head-left">
						<div class="data-head-title">昨日销售数据</div>
						<div class="data-time-block">
							<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
							<div class="data-time-title">10/18 周三</div>
							<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
						</div>
					</div>
					<div class="data-head-right">
						<div class="data-head-r-block data-head-r-bgcolor-w">
							<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
							<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
						</div>
						<div class="data-head-r-block data-head-r-bgcolor-b">
							<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
							<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
						</div>
					</div>
				</div>
				<div class="data-content">
					<div class="data-i-block" style="width: 1504px;height: 374px;"></div>
				</div>
			</div>
			<!-- 项目营销成果、项目营销指数 -->
			<div class="data-line-block">
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
			</div>
			<!-- 项目业主覆盖率、项目业主跟进率 -->
			<div class="data-line-block">
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
			</div>
			<!-- 签约车位分布、客户转化漏斗 -->
			<div class="data-line-block">
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
			</div>
			<!-- 置业顾问工作效率、置业顾问工作强度 -->
			<div class="data-line-block">
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
				<div class="data-line-item">
					<div class="data-head">
						<div class="data-head-left">
							<div class="data-head-title">昨日销售数据</div>
							<div class="data-time-block">
								<img src="../../assets/imgnew/arrow-c-l-g.png" class="data-time-img" />
								<div class="data-time-title">10/18 周三</div>
								<img src="../../assets/imgnew/arrow-c-r-g.png" class="data-time-img" />
							</div>
						</div>
						<div class="data-head-right">
							<div class="data-head-r-block data-head-r-bgcolor-w">
								<div class="data-head-r-title data-head-r-title-color-333">近12月</div>
								<img src="../../assets/imgnew/arrow-d-g.png" class="data-head-r-img" />
							</div>
							<div class="data-head-r-block data-head-r-bgcolor-b">
								<img src="../../assets/imgnew/i-download.png" class="data-head-r-img1" />
								<div class="data-head-r-title data-head-r-title-color-fff">下载</div>
							</div>
						</div>
					</div>
					<div class="data-content">
						<div class="data-i-block" style="width: 736px;height: 608px;"></div>
					</div>
				</div>
			</div>
			<div style="height: 90px;"></div>
		</div>
	</div>
</template>
<script>
	import html2canvas from "html2canvas";
	import columCahrts3 from "../../components/columnCharts3";
	import timeChange from "../../components/timeChange";
	import ownerCount from "../../components/ownerCount";
	import showOwner from "../../components/showOwner";
	import pieShow from "../../components/pieShow";
	import sellResult from "../../components/sellResult";
	export default {
		components: {
			charts3: columCahrts3,
			timeChange: timeChange,
			ownerCount,
			showOwner,
			pieShow,
			sellResult,
		},
		data() {
			return {
				// 工作强度
				IntensityData: {
					typeTimeC: 2,
				},
				// 销售趋势数组
				followBtn: [{
						id: 1,
						title: "跟进阶段",
					},
					{
						id: 2,
						title: "跟进户数",
					},
					{
						id: 3,
						title: "签约金额",
					},
				],
				// 实时销售数据(模拟)
				nowSellData: [{
						title: "跟进客户",
						num: 819,
						bylastDay: 10.11,
						sevenDay: -9.21,
						count: "户",
					},
					{
						title: "带看客户",
						num: 22,
						bylastDay: 4.71,
						sevenDay: -2.72,
						count: "个",
					},
					{
						title: "认购车位",
						num: 361,
						bylastDay: -28.14,
						sevenDay: 12.24,
						count: "个",
					},
					{
						title: "签约车位",
						num: 1161.33,
						bylastDay: 48.13,
						sevenDay: -22.2,
						count: "个",
					},
					{
						title: "签约金额",
						num: 521,
						bylastDay: -8.1,
						sevenDay: 32.23,
						count: "万元",
					},
				],
				// 项目判断
				projectIf: false,
				// 传给时间选择组件
				timeDatas: {
					typeTimeC: 2,
				},
				timeData: {
					typeTimeC: 1,
				},
				mouthText: "近12个月",
				mouthRange: 12,
				nearType: false,
				// 日期格式
				dateFormat: "MM / dd",
				// 月份格式
				mouthFormat: "yyyy-MM",
				// 选择月份
				chooseMouth: "",
				// 选择日期
				chooseDate: "",
				// 星期几
				weekday: "",
				activeIndex: 0,
				powerIndex: 0,
				// 柱形图1按钮
				columData: [{
						id: 1,
						title: "签约金额",
					},
					{
						id: 2,
						title: "签约数量",
					},
				],
				// 柱形图2按钮
				powerData: [{
						id: 1,
						title: "全部",
					},
					{
						id: 2,
						title: "电话",
					},
					{
						id: 3,
						title: "微信",
					},
					{
						id: 4,
						title: "面对面",
					},
				],
				value1: "",
				// 区域显隐
				areaIf: false,
				// 区域数组
				areaData: [{
						id: "1",
						title: "区域1"
					},
					{
						id: "2",
						title: "区域2"
					},
					{
						id: "3",
						title: "区域3"
					},
				],
				// 选择月份
				mouthDate: [{
						id: "1",
						title: "近12个月",
						mouth: 12
					},
					{
						id: "2",
						title: "近6个月",
						mouth: 6
					},
					{
						id: "3",
						title: "近3个月",
						mouth: 3
					},
				],
				// 全部项目
				projectData: [{
						id: "1",
						title: "项目1"
					},
					{
						id: "2",
						title: "项目2"
					},
					{
						id: "3",
						title: "项目3"
					},
				],
				//项目营销数据模拟
				yxdata: [
					"信华国际商务中心",
					"星期二",
					"星期三",
					"星期四",
					"星期五",
					"星期六",
					"星期七",
					"星期八",
					"星期九",
					"星期十",
				],
			};
		},
		mounted() {
			document.documentElement.setAttribute("theme", "dark");
			this.drawLine();
			// this.drawColumnCharts();
			this.drawnowFollow();
			// this.drawPowerCharts();
			this.getNowDate();
			const nowMouth = new Date();
			this.chooseMouth = this.getPreviousMonths(nowMouth, "prev");
			this.getWorkPower();
		},
		methods: {
			// 获取置业工作强度子组件值
			getWorkPower() {
				console.log(this.$refs.workPower.chooseMouth);
			},
			// 全部项目下拉
			allprojectClick() {
				document.documentElement.setAttribute("theme", "light");
				this.projectIf = !this.projectIf;
			},
			// 子项目点击
			projectClick(res) {
				this.projectIf = !this.projectIf;
				this.$router.push({
					path: "/pFullPage",
					// 向子项目页面传值
					query: {
						id: res.id,
					},
				});
			},
			// 销售趋势接受返回值
			getDayTime(res) {
				console.log(res);
			},
			// 选择月份下拉
			selectMouth(res) {
				this.mouthText = res.title;
				this.mouthRange = res.mouth;
			},
			// 选择月份
			chooseMouths(res) {
				this.chooseMouth = res;
			},
			// 计算月份
			getPreviousMonths(res, type) {
				// 获取当前日期
				let currentDate = new Date(res);
				let nowYear = currentDate.getFullYear();
				// 获取当前月份
				let currentMonth = currentDate.getMonth() + 1; // 返回值为 0-11，需要加 1
				// 计算12个月前的年份和月份
				let year = currentDate.getFullYear();
				if (type == "next") {
					let month = currentMonth + this.mouthRange;
					if (month > 12) {
						year += 1;
						month -= 12;
					}
					return [nowYear + "-" + currentMonth, year + "-" + month];
				} else if (type == "prev") {
					let month = currentMonth - this.mouthRange;

					// 如果计算出的月份小于 1，需要向前推 1 年
					if (month < 1) {
						year -= 1;
						month += 12;
					}
					return [year + "-" + month, nowYear + "-" + currentMonth];
				}
			},

			// 上一个月
			prevMouth() {
				// 图表转换成canvas
				// 下载图片
				// html2canvas(document.getElementById("myChart")).then(function (canvas) {
				//   var img = canvas
				//     .toDataURL("image/png")
				//     .replace("image/png", "image/octet-stream");
				//   // 创建a标签，实现下载
				//   var creatIMg = document.createElement("a");
				//   creatIMg.download = "图表.png"; // 设置下载的文件名，
				//   creatIMg.href = img; // 下载url
				//   document.body.appendChild(creatIMg);
				//   creatIMg.click();
				//   creatIMg.remove(); // 下载之后把创建的元素删除
				// });
				this.chooseMouth = this.getPreviousMonths(this.chooseMouth[0], "prev");
			},
			// 下一个月
			nextMouth() {
				this.chooseMouth = this.getPreviousMonths(this.chooseMouth[1], "next");
			},
			//销售趋势下拉
			nearDateClick() {
				this.nearType = !this.nearType;
			},
			// 封装(传入时间、分类)
			preWeeks(day, type) {
				// 获取传入日期
				const days = new Date(day);
				const countDate = new Date(days);
				//根据type进行判断
				if (type == "prev") {
					// 计算前一天的日期
					countDate.setDate(countDate.getDate() - 1);
				} else if (type == "next") {
					countDate.setDate(countDate.getDate() + 1);
				}
				const year = countDate.getFullYear();
				// 获取月份
				const month = countDate.getMonth() + 1;
				// 获取日期
				const newday = countDate.getDate();
				// 获取星期几
				const weekday = countDate.getDay();
				// 定义星期几的文本表示
				const weekdayText = [
					"星期日",
					"星期一",
					"星期二",
					"星期三",
					"星期四",
					"星期五",
					"星期六",
				];
				return [year + "-" + month + "-" + newday, weekdayText[weekday]];
			},
			// 上一周
			prevWeek() {
				const prevData = this.preWeeks(this.chooseDate, "prev");
				this.chooseDate = prevData[0];
				this.weekday = prevData[1];
				this.dateFormat = `MM / dd ${this.weekday}`;
			},
			// 下一周
			nextDay() {
				const nextData = this.preWeeks(this.chooseDate, "next");
				this.chooseDate = nextData[0];
				this.weekday = nextData[1];
				this.dateFormat = `MM / dd ${this.weekday}`;
			},
			// 获取当前日期
			getNowDate() {
				// 获取当前日期对象
				const currentDate = new Date();
				this.chooseDate = this.preWeeks(currentDate)[0];
				this.weekday = this.preWeeks(currentDate)[1];
				this.dateFormat = `MM / dd ${this.weekday}`;
			},
			// 选择日期
			chooseDates(res) {
				this.weekday = this.preWeeks(res)[1];
				this.dateFormat = `MM / dd ${this.weekday}`;
				this.chooseDate = res;
			},
			// 签约金额
			amountClick(item, index) {
				this.activeIndex = index;
			},
			// 销售强度
			powerClick(item, index) {
				this.powerIndex = index;
			},
			// 点击区域下拉
			areaClick() {
				this.areaIf = !this.areaIf;
			},

			// 区域点击详情
			areaDataClick(res) {},
			// 实时跟进数据
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("myChart"));
				// 绘制图表
				myChart.setOption({
					// 调整与边框距离
					grid: {
						x: 70,
						y: 35,
						x2: 50,
						y2: 95,
					},
					// title: {
					//   text: "某楼盘销售情况",
					//   subtext: "纯属虚构",
					// },
					tooltip: {
						trigger: "axis",
					},
					legend: {
						show: false,
					},
					// toolbox: {
					//   show: true,
					//   feature: {
					//     mark: { show: true },
					//     dataView: { show: true, readOnly: false },
					//     magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
					//     restore: { show: true },
					//     saveAsImage: { show: true },
					//   },
					// },
					calculable: true,
					xAxis: [{
						type: "category",
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: "#568BBE",
							},
						},

						data: [
							"00:00",
							"01:00",
							"02:00",
							"03:00",
							"04:00",
							"05:00",
							"06:00",
							"07:00",
							"08:00",
							"09:00",
							"10:00",
							"11:00",
							"12:00",
							"13:00",
							"14:00",
							"15:00",
							"16:00",
							"17:00",
							"18:00",
							"19:00",
							"20:00",
							"21:00",
							"22:00",
							"23:00",
							"24:00",
						],
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: "#446BAC",
							},
						},
					}, ],
					yAxis: [{
						type: "value",
						splitLine: {
							show: true,
							lineStyle: {
								type: "dashed",
								color: "#305197",
							},
						},
						axisLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: "#446BAC",
							},
						},
					}, ],
					//折线颜色
					color: ["#00D6D9", "#FDAE58", "#FF365B"],
					series: [{
							name: "成交",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#2C4E79"
									}
								},
							},
							data: [
								45, 74, 11, 32, 5, 73, 4, 59, 97, 8, 81, 23, 98, 42, 93, 53, 84,
								39, 36, 22, 27, 40, 94, 99, 31,
							],
						},
						{
							name: "预购",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#40458F"
									}
								},
							},
							data: [
								6, 20, 39, 24, 70, 81, 26, 13, 37, 40, 8, 2, 98, 69, 57, 11, 76,
								56, 41, 80, 15, 71, 45, 46, 85,
							],
						},
						{
							name: "意向",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#153E98"
									}
								},
							},
							data: [
								77, 40, 89, 34, 70, 81, 76, 73, 37, 49, 78, 92, 98, 69, 57, 91,
								76, 26, 21, 80, 55, 71, 35, 56, 82,
							],
						},
					],
				});
			},
			// 实时跟进数据
			drawnowFollow() {
				// 基于准备好的dom，初始化echarts实例
				let myChartNowfollow = this.$echarts.init(
					document.getElementById("myChartNowfollow")
				);
				// 绘制图表
				myChartNowfollow.setOption({
					// 调整与边框距离
					grid: {
						x: 70,
						y: 35,
						x2: 50,
						y2: 95,
					},
					tooltip: {
						trigger: "axis",
					},
					legend: {
						show: false,
					},
					calculable: true,
					xAxis: [{
						type: "category",
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: "#568BBE",
							},
						},

						data: [
							"00:00",
							"01:00",
							"02:00",
							"03:00",
							"04:00",
							"05:00",
							"06:00",
							"07:00",
							"08:00",
							"09:00",
							"10:00",
							"11:00",
							"12:00",
							"13:00",
							"14:00",
							"15:00",
							"16:00",
							"17:00",
							"18:00",
							"19:00",
							"20:00",
							"21:00",
							"22:00",
							"23:00",
							"24:00",
						],
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: "#446BAC",
							},
						},
					}, ],
					yAxis: [{
						type: "value",
						splitLine: {
							show: true,
							lineStyle: {
								type: "dashed",
								color: "#305197",
							},
						},
						axisLine: {
							show: false,
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: "#446BAC",
							},
						},
					}, ],
					//折线颜色
					color: ["#A7EF38", "#CF43FD", "#3492F9"],
					series: [{
							name: "今天",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#2C4E79"
									}
								},
							},
							data: [
								45, 74, 11, 32, 5, 73, 4, 59, 97, 8, 81, 23, 98, 42, 93, 53, 84,
								39, 36, 22, 27, 40, 94, 99, 31,
							],
						},
						{
							name: "1天前",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#40458F"
									}
								},
							},
							data: [
								6, 20, 39, 24, 70, 81, 26, 13, 37, 40, 8, 2, 98, 69, 57, 11, 76,
								56, 41, 80, 15, 71, 45, 46, 85,
							],
						},
						{
							name: "7天前",
							type: "line",
							smooth: true,
							symbol: "none",
							itemStyle: {
								normal: {
									areaStyle: {
										type: "default",
										color: "#153E98"
									}
								},
							},
							data: [
								77, 40, 89, 34, 70, 81, 76, 73, 37, 49, 78, 92, 98, 69, 57, 91,
								76, 26, 21, 80, 55, 71, 35, 56, 82,
							],
						},
					],
				});
			},
		},
	};
</script>
<style scoped>
	
	.data-line-block {
		margin: 0 90px 0 90px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.data-line-item {
		display: flex;
		flex-direction: column;
	}
	
	.data-line-size {
		width: 736px;
		height: 608px;
	}
	
	.data-block {
		margin: 0 90px 0 90px;
		display: flex;
		flex-direction: column;
	}
	
	.data-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 80px;
	}
	
	.data-head-left {
		display: flex;
		align-items: center;
	}
	
	.data-head-title {
		height: 34px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size: 24px;
		color: #333333;
		line-height: 34px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	
	.data-time-block {
		display: flex;
		align-items: center;
		margin-left: 16px;
	}
	
	.data-time-img {
		width: 16px;
		height: 16px;
	}
	
	.data-time-title {
		height: 28px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 20px;
		color: #666666;
		line-height: 28px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin: 0 8px 0 8px;
	}
	
	.data-time-dot {
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #75BE9B;
	}
	
	.data-head-right {
		display: flex;
		align-items: center;
	}
	
	.data-head-r-block {
		display: flex;
		align-items: center;
		
		height: 32px;
		border-radius: 16px;
		padding: 0 8px 0 8px;
		
		margin-left: 16px;
	}
	
	.data-head-r-bgcolor-w {
		background: #FFFFFF;
	}
	
	.data-head-r-bgcolor-b {
		background: #7A87E1;
	}
	
	.data-head-r-title {
		height: 32px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 20px;
		
		line-height: 32px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	
	.data-head-r-title-color-333 {
		color: #333333;
	}
	
	.data-head-r-title-color-fff {
		color: #FFFFFF;
	}
	
	.data-head-r-img {
		width: 8px;
		height: 8px;
		margin-left: 4px;
	}
	
	.data-head-r-img1 {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}
	
	.data-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.data-i-block {
		background: #FFFFFF;
		border-radius: 16px;
	}
	
	.data-i-size {
		width: 288px;
		height: 120px;
	}


	@media screen and (max-width: 480px) {
		.fullPage-body {
			width: 100% !important;
		}

		.blockFirst {
			display: none !important;
		}

		.blockThird {
			display: none !important;
		}
	}

	.fullPage {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow-x: hidden;
		overflow-y: hidden;

		background: linear-gradient( 78deg, #F4F5F7 0%, #E5EBFA 100%);
	}

	.fullPage-body {
		width: 100%;
	}

	.nav {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.nav-block {
		width: 100%;
		background: #FFFFFF;
		opacity: 0.8;
		
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.blockFirst {
		height: 64px;
	}
	
	.blockFirst-l-title {
		margin-left: 7px;
		font-family: FZZhengHeiS-EB-GB;
		font-weight: bolder;
		font-size: 26px;
		color: #333333;
		line-height: 64px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	
	.blockFirst-l-img {
		width: 24px;
		height: 24px;
	}
	
	.blockFirst-r-title {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		line-height: 25px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	
	.blockFirst-r-img {
		width: 16px;
		height: 16px;
	}
	
	.nav-margin-left {
		margin-left: 90px;
		display: flex;
		align-items: center;
	}
	
	.nav-margin-right {
		margin-right: 90px;
		display: flex;
		align-items: center;
	}

	.blockSecond {
		height: 72px;
		box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.08);
	}
	
	.nav-second-l {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100px;
		height: 40px;
		background: #7A87E1;
		border-radius: 16px 16px 16px 16px;
	}
	
	.nav-second-l-title {
		height: 25px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 25px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	
	.nav-second-l-img {
		width: 8px;
		height: 8px;
		margin-left: 4px;
	}
	
	.nav-second-c {
		display: flex;
		align-items: center;
		width: 100px;
		height: 40px;
		margin-left: 24px;
	}
	
	.nav-second-c-title {
		height: 25px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
		line-height: 25px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	
	.nav-second-c-img {
		width: 8px;
		height: 8px;
		margin-left: 4px;
	}
	
	.nav-second-r {
		display: flex;
		align-items: center;
		margin-left: 96px;
	}
	
	.nav-second-r-title {
		height: 25px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #666666;
		line-height: 25px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	
	.nav-second-r-margin {
		margin-left: 24px;
	}

</style>


// WEBPACK FOOTER //
// src/views/fullPage/index1.vue